// import React from "react";

// export const DeleteIcon = ({ onclick, id }) => {
//   return (
//     <span
//       data-toggle="modal"
//       data-target={"#deleteConfirmation" + (id || "")}
//       onClick={onclick}
//       className="mx-2"
//     >
//       <i className="flaticon-delete icon-md text-dark font-weight-bold text-hover-danger cursor-pointer m-0" />
//     </span>
//   );
// };


import React from "react";

export const DeleteIcon = ({ onclick, id, disabled = false }) => {
  const handleClick = (e) => {
    if (!disabled && onclick) {
      onclick(e);
    }
  };

  return (
    <span
      data-toggle={!disabled ? "modal" : undefined}
      data-target={!disabled ? "#deleteConfirmation" + (id || "") : undefined}
      onClick={handleClick}
      className={`mx-2 ${disabled ? "disabled" : "cursor-pointer"}`}
    >
      <i
        className={`flaticon-delete icon-md text-dark font-weight-bold ${
          disabled ? "" : "text-hover-danger"
        }`}
      />
    </span>
  );
};
